import { ReactNode } from "react";
import Button, { ButtonProps } from "react-bootstrap/Button";

const PrimaryButton = (props: { children: ReactNode; rest?: ButtonProps }) => {
  return (
    <Button variant="primary" bsPrefix="btn-default bg-green" {...props.rest}>
      {props.children}
    </Button>
  );
};

export default PrimaryButton;
